import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Btn } from "@/components/ui-kit";
import { fmtDate } from "@/lib/constants";
import { Bell, CheckCheck, AlertTriangle, Info, CheckCircle2, XCircle } from "lucide-react";

const ICONS = { info: Info, warning: AlertTriangle, success: CheckCircle2, error: XCircle };
const CLS = { info: "text-blue-500", warning: "text-amber-500", success: "text-emerald-500", error: "text-red-500" };

export default function Notifications() {
  const [notes, setNotes] = useState([]);
  const load = () => api.get("/notifications").then((r) => setNotes(r.data));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const markRead = async (n) => { await api.post(`/notifications/${n.id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="space-y-4" data-testid="notifications-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-2xl font-bold uppercase tracking-tight sm:text-3xl flex items-center gap-2"><Bell size={24} /> Notification Center</h1>
          <p className="text-sm text-muted-foreground">Pending approvals · low stock · delayed jobs</p>
        </div>
        <Btn variant="outline" onClick={markAll} data-testid="mark-all-read-btn"><CheckCheck size={15} /> Mark all read</Btn>
      </div>
      <div className="space-y-2">
        {notes.map((n) => {
          const Icon = ICONS[n.level] || Info;
          return (
            <Card key={n.id} onClick={() => markRead(n)} data-testid={`note-${n.id}`}
              className={`flex cursor-pointer items-start gap-3 p-3 ${n.is_read ? "opacity-60" : "border-l-2 border-l-primary"}`}>
              <Icon size={18} className={`mt-0.5 shrink-0 ${CLS[n.level]}`} />
              <div className="min-w-0 flex-1">
                <div className="font-semibold">{n.title}</div>
                <div className="text-sm text-muted-foreground">{n.message}</div>
                <div className="font-mono text-[10px] text-muted-foreground">{fmtDate(n.created_at)}</div>
              </div>
              {!n.is_read && <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-primary" />}
            </Card>
          );
        })}
        {notes.length === 0 && <p className="text-sm text-muted-foreground">No notifications.</p>}
      </div>
    </div>
  );
}
